import Hotjar from "@hotjar/browser";
import { selectUserDb } from "../store/slices/session/sessionSelector";
import { useSelector } from "react-redux";
import { useEffect } from "react";

export const useIdentifyUserHotjar = () => {
  const userDb = useSelector(selectUserDb);

  useEffect(() => {
    if (userDb) {
      Hotjar.identify(userDb.id, {
        firstName: userDb.firstName,
        lastName: userDb.lastName,
        email: userDb.email,
        phone: userDb.phone,
        role: userDb.role,
        active: userDb.active,
      });
    }
  }, [userDb]);
};
